import { useSearchParam } from '../../hooks/useSearchParam';
import { useState } from 'react';

export function useAssetsMaintenanceFilterInitialValue(): boolean | null {
  const searchParam = useSearchParam('maintenance');

  return useState(() => (searchParam === null ? null : searchParam === 'true'))[0];
}
